"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _user = require("@/api/user");
var _SliderVerifyDialog = _interopRequireDefault(require("@/components/SliderVerifyDialog"));
var _md = require("@/utils/md5");
var _verifyCodeCrypto = require("@/utils/verifyCodeCrypto");
var _loginPayloadCrypto = require("@/utils/loginPayloadCrypto");
var _wechat = require("@/libs/wechat");
var _loginErrorCode = require("@/constants/loginErrorCode");
var _sliderSecurity = require("@/utils/sliderSecurity");
var _loginCredential = require("@/utils/loginCredential");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 保持你原来的 script 部分完全不变
var _default = exports.default = {
  name: 'Login',
  components: {
    SliderVerifyDialog: _SliderVerifyDialog.default
  },
  data: function data() {
    return {
      captchatImg: '',
      loginLogo: '',
      sliderVisible: false,
      captchaFailCount: 0,
      captchaLocked: false,
      captchaLoading: false,
      sliderRequired: false,
      pendingSliderPass: false,
      captchaSessionValid: false,
      fullWidth: document.body.clientWidth,
      loginForm: {
        account: '',
        password: '',
        verifyCodeKey: '',
        verifyCode: '',
        wxCode: ''
      },
      loginRules: {
        account: [{
          required: true,
          trigger: 'blur',
          message: '请输入账号'
        }, {
          validator: function validator(rule, value, callback) {
            if (!(0, _loginCredential.validateLoginAccount)(value)) {
              callback(new Error(_loginCredential.LOGIN_ACCOUNT_MESSAGE));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          message: '请输入密码'
        }, {
          validator: function validator(rule, value, callback) {
            if (!(0, _loginCredential.validateLoginPassword)(value)) {
              callback(new Error(_loginCredential.LOGIN_PASSWORD_MESSAGE));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        verifyCode: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      passwordType: 'password',
      loading: false,
      redirect: undefined,
      otherQuery: {}
    };
  },
  computed: {
    sliderBlocked: function sliderBlocked() {
      return this.sliderRequired && !this.pendingSliderPass && !this.captchaSessionValid;
    }
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;
    document.onkeydown = function (e) {
      if (_this.$route.path.includes('login') && e.keyCode === 13) {
        _this.handleLogin();
      }
    };
    window.addEventListener('resize', this.handleResize);
  },
  mounted: function mounted() {
    this.$store.dispatch('user/resetToken');
    var synced = (0, _sliderSecurity.syncSliderSecurityStateOnPageLoad)();
    if (synced.locked) {
      this.sliderRequired = true;
      this.prepareSliderGateWithoutOpen();
      return;
    }
    this.sliderRequired = false;
    this.captchaLocked = false;
    this.getCaptcha();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.fullWidth = document.body.clientWidth;
    },
    showPwd: function showPwd() {
      var _this2 = this;
      this.passwordType = this.passwordType === 'password' ? '' : 'password';
      this.$nextTick(function () {
        return _this2.$refs.pwd.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this3 = this;
      if (this.loading) return;
      if (this.sliderBlocked) {
        this.openSliderGate();
        return;
      }
      this.$refs.loginForm.validate(function (valid) {
        if (!valid) return;
        _this3.loading = true;
        var encryptedPayload = (0, _loginPayloadCrypto.encryptLoginPayload)({
          account: (0, _md.md5)(_this3.loginForm.account),
          accountInput: _this3.loginForm.account,
          password: (0, _md.md5)(_this3.loginForm.password),
          verifyCodeKey: (0, _md.md5)(_this3.loginForm.verifyCodeKey),
          verifyCode: (0, _md.md5)(_this3.loginForm.verifyCode),
          timestamp: Date.now(),
          nonce: (0, _loginPayloadCrypto.createLoginNonce)()
        });
        _this3.$store.dispatch('user/login', {
          payload: encryptedPayload,
          accountInput: _this3.loginForm.account,
          passwordInput: _this3.loginForm.password
        }).then(function () {
          (0, _sliderSecurity.resetSliderSecurityState)();
          _this3.$router.push({
            path: _this3.redirect || '/',
            query: _this3.otherQuery
          });
        }).catch(function (err) {
          _this3.handleLoginError(err);
        }).finally(function () {
          _this3.loading = false;
        });
      });
    },
    getCaptcha: function getCaptcha() {
      var _this4 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var silent = options.silent === true;
      if (this.captchaLoading) return;
      if (this.sliderRequired && !this.pendingSliderPass) {
        this.captchaSessionValid = false;
        if (silent) {
          this.requireSliderGate();
        } else {
          this.openSliderGate();
        }
        return;
      }
      if (this.captchaLocked) return;
      this.captchaLoading = true;
      (0, _user.captchaApi)().then(function (res) {
        var payload = (0, _verifyCodeCrypto.decryptVerifyCodePayload)(res);
        _this4.captchatImg = window.atob(payload.image);
        _this4.loginForm.verifyCodeKey = payload.verifyCodeKey;
        _this4.pendingSliderPass = false;
        _this4.captchaSessionValid = true;
        _this4.captchaLocked = false;
        _this4.sliderRequired = false;
        (0, _sliderSecurity.clearSliderRequired)();
      }).catch(function (err) {
        _this4.pendingSliderPass = false;
        _this4.captchaSessionValid = false;
        var _normalizeLoginError = (0, _loginErrorCode.normalizeLoginError)(err),
          message = _normalizeLoginError.message;
        if ((0, _loginErrorCode.isNetworkError)(err)) {
          _this4.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
          return;
        }
        if ((0, _loginErrorCode.isSliderVerifyRequired)(err)) {
          if (silent) {
            _this4.requireSliderGate();
          } else {
            _this4.openSliderGate();
          }
          return;
        }
        if ((0, _loginErrorCode.isSecurityThreat)(err)) {
          _this4.captchatImg = '';
          _this4.captchaLocked = false;
          _this4.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
          return;
        }
        if ((0, _loginErrorCode.isLoginRateLimit)(err)) {
          _this4.captchatImg = '';
          _this4.$message.warning((0, _loginErrorCode.getLoginDisplayMessage)(err));
          return;
        }
        if (message) {
          _this4.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
        }
      }).finally(function () {
        _this4.captchaLoading = false;
      });
    },
    invalidateCaptchaForSlider: function invalidateCaptchaForSlider() {
      var _this5 = this;
      this.captchatImg = '';
      this.loginForm.verifyCodeKey = '';
      this.loginForm.verifyCode = '';
      this.captchaLocked = true;
      this.$nextTick(function () {
        _this5.$refs.loginForm && _this5.$refs.loginForm.clearValidate('verifyCode');
      });
    },
    prepareSliderGateWithoutOpen: function prepareSliderGateWithoutOpen() {
      this.pendingSliderPass = false;
      this.captchaSessionValid = false;
      this.captchatImg = '';
      this.loginForm.verifyCodeKey = '';
      this.captchaLocked = true;
    },
    requireSliderGate: function requireSliderGate() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$openDialog = options.openDialog,
        openDialog = _options$openDialog === void 0 ? false : _options$openDialog;
      (0, _sliderSecurity.markSliderRequired)();
      this.sliderRequired = true;
      this.pendingSliderPass = false;
      this.captchaSessionValid = false;
      this.invalidateCaptchaForSlider();
      if (openDialog) {
        this.sliderVisible = true;
      }
    },
    openSliderGate: function openSliderGate() {
      this.requireSliderGate({
        openDialog: true
      });
    },
    handleLoginError: function handleLoginError(err) {
      var _this6 = this;
      this.loginForm.verifyCode = '';
      this.$nextTick(function () {
        _this6.$refs.loginForm && _this6.$refs.loginForm.clearValidate('verifyCode');
      });
      if ((0, _loginErrorCode.isNetworkError)(err)) {
        this.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
        return;
      }
      if ((0, _loginErrorCode.isSecurityThreat)(err)) {
        this.captchatImg = '';
        this.captchaLocked = false;
        this.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
        return;
      }
      if ((0, _loginErrorCode.isLoginRateLimit)(err)) {
        this.captchatImg = '';
        this.$message.warning((0, _loginErrorCode.getLoginDisplayMessage)(err));
        return;
      }
      if ((0, _loginErrorCode.isSliderVerifyRequired)(err)) {
        this.openSliderGate();
        return;
      }
      if ((0, _loginErrorCode.isCaptchaExpired)(err)) {
        this.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
        this.refreshCaptchaAfterInvalid();
        return;
      }
      if ((0, _loginErrorCode.isCaptchaInvalid)(err)) {
        this.captchaFailCount += 1;
        this.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
        if (this.captchaFailCount >= 3) {
          this.requireSliderGate();
          return;
        }
        this.refreshCaptchaAfterInvalid();
        return;
      }
      this.$message.error((0, _loginErrorCode.getLoginDisplayMessage)(err));
      this.refreshCaptchaIfAllowed();
    },
    refreshCaptchaAfterInvalid: function refreshCaptchaAfterInvalid() {
      this.captchaSessionValid = false;
      this.loginForm.verifyCodeKey = '';
      this.captchaLocked = false;
      if (this.sliderRequired && !this.pendingSliderPass) {
        return;
      }
      this.getCaptcha({
        silent: true
      });
    },
    refreshCaptchaIfAllowed: function refreshCaptchaIfAllowed() {
      if (this.captchaLocked) return;
      if (this.sliderRequired && !this.pendingSliderPass) return;
      this.getCaptcha();
    },
    onSliderPassed: function onSliderPassed() {
      this.captchaLocked = false;
      this.pendingSliderPass = true;
      this.sliderRequired = false;
      this.captchaSessionValid = false;
      (0, _sliderSecurity.clearSliderRequired)();
      this.getCaptcha();
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') acc[cur] = query[cur];
        return acc;
      }, {});
    }
  }
};